import { render, staticRenderFns } from "./bdqk.vue?vue&type=template&id=62f2aece"
import script from "./bdqk.vue?vue&type=script&lang=js"
export * from "./bdqk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports